import { useTranslation } from '@frontend/i18n';
import { usePopoverMenu } from '@frontend/design-system';
import { ConversationTypeFilter } from '../../../types';
import { InboxFiltersPopoverSubmenuItem } from '../inbox-filters-popover-submenu-item';
import { ConversationTypeFilterPopoverMenu } from './conversation-type-filter-popover';

type ConversationTypeFilterPopoverSubmenuItemProps = {
  onSelect: (conversationType: ConversationTypeFilter) => void;
  selectedConversationType: ConversationTypeFilter | '';
  divider?: 'top' | 'bottom';
  trackingId?: string;
};

export const ConversationTypeFilterPopoverSubmenuItem = ({
  onSelect,
  selectedConversationType,
  divider,
  trackingId,
}: ConversationTypeFilterPopoverSubmenuItemProps) => {
  const { t } = useTranslation('inbox');
  const conversationTypePopover = usePopoverMenu<HTMLButtonElement>({
    placement: 'right-start',
    middlewareOptions: {
      offset: {
        mainAxis: 0,
        crossAxis: -8,
      },
    },
  });

  return (
    <>
      <InboxFiltersPopoverSubmenuItem
        getSubmenuTriggerProps={conversationTypePopover.getTriggerProps}
        iconName='chat-small'
        label={t('Conversation Type')}
        count={selectedConversationType ? 1 : 0}
        divider={divider}
        trackingId={trackingId}
      />
      <ConversationTypeFilterPopoverMenu
        getMenuProps={conversationTypePopover.getMenuProps}
        getItemProps={conversationTypePopover.getItemProps}
        onSelect={onSelect}
        selectedConversationType={selectedConversationType}
      />
    </>
  );
};
